import { createStore, applyMiddleware } from "redux";
import rootReducer from "./reducers";
import thunk from "redux-thunk";
import { liveSwitchMiddleware } from "../../LiveSwitch/liveSwitchMiddleware";
import { eventDrivenAPIMiddleware } from "./middleware/eventDrivenAPIMiddleware";
///@ts-ignore

export default function configureStore(initialState) {
    return createStore(
        rootReducer,
        initialState,
        applyMiddleware(thunk, liveSwitchMiddleware, eventDrivenAPIMiddleware)
    );
}
